import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Play, Download, Share2, Clock } from "lucide-react";

const CACHE_V = "2";

const VIDEOS = [
  { titulo: "Filme Completo — todos os vídeos em um só", arquivo: "HeveaTalent_Completo.mp4", dur: "14 min", destaque: true, desc: "Assista tudo de uma vez: do cadastro até o controle de perdas." },
  { titulo: "O que é a HeveaTalent + Criando sua conta", arquivo: "HeveaTalent_Facil_1_conta.mp4", dur: "2:42", desc: "Primeiros passos: conheça o app e crie sua conta grátis." },
  { titulo: "Configurando o seringal (responsável)", arquivo: "HeveaTalent_Facil_1b_config.mp4", dur: "1:23", desc: "Cadastre sua propriedade, talhões e metas de produção." },
  { titulo: "Anotando a sangria (responsável)", arquivo: "HeveaTalent_Facil_2_sangria.mp4", dur: "2:15", desc: "Registre a sangria do dia a dia em poucos toques." },
  { titulo: "Achando trabalho", arquivo: "HeveaTalent_Facil_3_trabalho.mp4", dur: "1:06", desc: "Como encontrar vagas e se candidatar pelo Balcão de Empregos." },
  { titulo: "Comunidade: notícias e dicas", arquivo: "HeveaTalent_Facil_4_comunidade.mp4", dur: "0:48", desc: "Fique por dentro das novidades da heveicultura." },
  { titulo: "Cotações: o preço da borracha", arquivo: "HeveaTalent_Facil_5_cotacoes.mp4", dur: "0:55", desc: "Acompanhe os preços CEPEA/IEA e saiba quanto vale sua produção." },
  { titulo: "Marketplace: compre e venda", arquivo: "HeveaTalent_Facil_6_marketplace.mp4", dur: "0:41", desc: "Anuncie e encontre equipamentos, insumos e serviços." },
  { titulo: "Balcão e Cursos (sem conta)", arquivo: "HeveaTalent_Facil_7_balcao_cursos.mp4", dur: "1:26", desc: "Vagas e cursos gratuitos SENAR, sem precisar de cadastro." },
  { titulo: "Perdas: quanto custa um dia parado (responsável)", arquivo: "HeveaTalent_Facil_8_perdas.mp4", dur: "3:03", desc: "Veja quanto a chuva e dias parados custam no seu bolso." },
];

const VideoCard = ({ video, index }) => {
  const url = `/divulgacao/videos/${video.arquivo}`;
  const fullUrl = `${window.location.origin}${url}`;
  const waMsg = encodeURIComponent(`🎬 ${video.titulo}\n${fullUrl}`);

  return (
    <div
      data-testid={`tutorial-card-${index}`}
      className={`bg-white rounded-xl shadow-sm border overflow-hidden ${video.destaque ? "border-amber-300 ring-2 ring-amber-200" : "border-green-100"}`}
    >
      {video.destaque && (
        <div className="bg-amber-400 text-green-900 text-xs font-bold text-center py-1.5">
          ⭐ RECOMENDADO — COMECE POR AQUI
        </div>
      )}
      <video
        controls
        playsInline
        preload="none"
        poster=""
        className="w-full bg-black aspect-video"
        data-testid={`tutorial-video-${index}`}
      >
        <source src={`${url}?v=${CACHE_V}`} type="video/mp4" />
      </video>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-green-900 text-sm md:text-base leading-snug">{video.titulo}</h3>
          <span className="flex items-center gap-1 text-xs text-gray-500 shrink-0 mt-0.5">
            <Clock className="w-3 h-3" /> {video.dur}
          </span>
        </div>
        <p className="text-xs md:text-sm text-gray-600 mt-1">{video.desc}</p>
        <div className="flex flex-wrap gap-2 mt-3">
          <a
            href={`https://wa.me/?text=${waMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`tutorial-share-${index}`}
            className="inline-flex items-center gap-1.5 bg-[#25D366] text-white text-xs font-semibold px-3 py-2 rounded-full hover:opacity-90 transition-opacity"
          >
            <Share2 className="w-3.5 h-3.5" /> Enviar no WhatsApp
          </a>
          <a
            href={url}
            download
            data-testid={`tutorial-download-${index}`}
            className="inline-flex items-center gap-1.5 bg-green-700 text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-green-800 transition-colors"
          >
            <Download className="w-3.5 h-3.5" /> Baixar
          </a>
        </div>
      </div>
    </div>
  );
};

export default function TutoriaisPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-green-50">
      <header className="hevea-header border-b border-green-200 sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="flex items-center h-14 sm:h-16 gap-3">
            <Link
              to="/"
              data-testid="tutoriais-back-link"
              className="flex items-center gap-1 text-white text-sm hover:opacity-80 transition-opacity"
            >
              <ArrowLeft className="w-4 h-4" /> Voltar
            </Link>
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-8 h-8 bg-white bg-opacity-20 rounded-lg">📺</div>
              <h1 className="text-base sm:text-lg font-bold text-white">Vídeos Tutoriais</h1>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6">
        <div className="bg-green-800 text-white rounded-xl p-4 md:p-5 mb-6">
          <p className="font-semibold text-sm md:text-base flex items-center gap-2">
            <Play className="w-4 h-4" /> Aprenda a usar a HeveaTalent em poucos minutos
          </p>
          <p className="text-green-100 text-xs md:text-sm mt-1">
            Os vídeos só carregam quando você aperta o play — não pesam no seu celular.
            Você também pode baixar ou enviar pelo WhatsApp para quem precisa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="tutoriais-grid">
          {VIDEOS.map((v, i) => (
            <div key={v.arquivo} className={v.destaque ? "md:col-span-2 md:max-w-xl md:mx-auto md:w-full" : ""}>
              <VideoCard video={v} index={i} />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
